/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { FormattedMessage, useIntl } from 'react-intl'
import _, { kebabCase } from 'lodash'
import { GMB_CURRENCY_CODE } from '~/constants/gmbCurrencyCode'
import { ArrowLeft, ChevronDown, ChevronUp, Plus, X } from 'react-feather'
import CreatableSelect from 'react-select/creatable'
import Select from 'react-select'
import { FormGroup, Modal, InputGroup, Input } from 'reactstrap'
import Textarea from '~/components/Textarea'
import { GMB_LANGUAGE_CODE } from '~/constants/gmbLanguageCode'
import { useParams } from 'react-router-dom'
import useAxios from 'axios-hooks'
import { toast } from 'react-toastify'

const ONE_BILLION = 1000000000

const PRICE_OPTIONS = [
  { value: 'NO_PRICE', label: <FormattedMessage id="No price" /> },
  { value: 'FREE', label: <FormattedMessage id="Free" /> },
  { value: 'FIXED', label: <FormattedMessage id="Fixed" /> },
]

const PRICE_STATES = {
  NO_PRICE: {
    priceDisabled: true,
    currencyDisabled: true,
  },
  FREE: {
    priceDisabled: true,
    currencyDisabled: false,
  },
  FIXED: {
    priceDisabled: false,
    currencyDisabled: false,
  },
}

const CURRENCY_CODE_OPTIONS = [
  { value: 'BRL', label: <FormattedMessage id="Brazilian Real" /> },
  { value: 'USD', label: <FormattedMessage id="US Dollar" /> },
  { value: 'EUR', label: <FormattedMessage id="Euro" /> },
  { value: 'GBP', label: <FormattedMessage id="Pound Sterling" /> },
  { value: 'CNY', label: <FormattedMessage id="Yuan Renminbi" /> },
  { value: 'JPY', label: <FormattedMessage id="Yen" /> },
  { value: 'RUB', label: <FormattedMessage id="Russian Ruble" /> },
  { value: 'ARS', label: <FormattedMessage id="Argentine Peso" /> },
  { value: 'BOB', label: <FormattedMessage id="Boliviano" /> },
  { value: 'COP', label: <FormattedMessage id="Colombian Peso" /> },
  { value: 'CLP', label: <FormattedMessage id="Chilean Peso" /> },
  { value: 'UYU', label: <FormattedMessage id="Peso Uruguayo" /> },
  { value: 'PYG', label: <FormattedMessage id="Guarani" /> },
  { value: 'AFN', label: <FormattedMessage id="Afghani" /> },
  { value: 'ALL', label: <FormattedMessage id="Lek" /> },
  { value: 'DZD', label: <FormattedMessage id="Algerian Dinar" /> },
  { value: 'AOA', label: <FormattedMessage id="Kwanza" /> },
  { value: 'XCD', label: <FormattedMessage id="East Caribbean Dollar" /> },
  { value: 'AMD', label: <FormattedMessage id="Armenian Dram" /> },
  { value: 'AWG', label: <FormattedMessage id="Aruban Florin" /> },
  { value: 'AUD', label: <FormattedMessage id="Australian Dollar" /> },
  { value: 'AZN', label: <FormattedMessage id="Azerbaijan Manat" /> },
  { value: 'BSD', label: <FormattedMessage id="Bahamian Dollar" /> },
  { value: 'BHD', label: <FormattedMessage id="Bahraini Dinar" /> },
  { value: 'BDT', label: <FormattedMessage id="Taka" /> },
  { value: 'BBD', label: <FormattedMessage id="Barbados Dollar" /> },
  { value: 'BYN', label: <FormattedMessage id="Belarusian Ruble" /> },
  { value: 'BZD', label: <FormattedMessage id="Belize Dollar" /> },
  { value: 'XOF', label: <FormattedMessage id="CFA Franc BCEAO" /> },
  { value: 'BMD', label: <FormattedMessage id="Bermudian Dollar-" /> },
  { value: 'INR', label: <FormattedMessage id="Indian Rupee" /> },
  { value: 'BTN', label: <FormattedMessage id="Ngultrum" /> },
  { value: 'BOV', label: <FormattedMessage id="Mvdol" /> },
  { value: 'BAM', label: <FormattedMessage id="Convertible Mark" /> },
  { value: 'BWP', label: <FormattedMessage id="Pula" /> },
  { value: 'NOK', label: <FormattedMessage id="Norwegian Krone" /> },
  { value: 'BND', label: <FormattedMessage id="Brunei Dollar" /> },
  { value: 'BGN', label: <FormattedMessage id="Bulgarian Lev" /> },
  { value: 'BIF', label: <FormattedMessage id="Burundi Franc" /> },
  { value: 'CVE', label: <FormattedMessage id="Cabo Verde Escudo" /> },
  { value: 'KHR', label: <FormattedMessage id="Riel" /> },
  { value: 'XAF', label: <FormattedMessage id="CFA Franc BEAC" /> },
  { value: 'CAD', label: <FormattedMessage id="Canadian Dollar" /> },
  { value: 'KYD', label: <FormattedMessage id="Cayman Islands Dollar" /> },
  { value: 'CLF', label: <FormattedMessage id="Unidad de Fomento" /> },
  { value: 'COU', label: <FormattedMessage id="Unidad de Valor Real" /> },
  { value: 'KMF', label: <FormattedMessage id="Comorian Franc " /> },
  { value: 'CDF', label: <FormattedMessage id="Congolese Franc" /> },
  { value: 'NZD', label: <FormattedMessage id="New Zealand Dollar" /> },
  { value: 'CRC', label: <FormattedMessage id="Costa Rican Colon" /> },
  { value: 'CUP', label: <FormattedMessage id="Cuban Peso" /> },
  { value: 'CUC', label: <FormattedMessage id="Peso Convertible" /> },
  {
    value: 'ANG',
    label: <FormattedMessage id="Netherlands Antillean Guilder" />,
  },
  { value: 'CZK', label: <FormattedMessage id="Czech Koruna" /> },
  { value: 'DKK', label: <FormattedMessage id="Danish Krone" /> },
  { value: 'DJF', label: <FormattedMessage id="Djibouti Franc" /> },
  { value: 'DOP', label: <FormattedMessage id="Dominican Peso" /> },
  { value: 'EGP', label: <FormattedMessage id="Egyptian Pound" /> },
  { value: 'SVC', label: <FormattedMessage id="El Salvador Colon" /> },
  { value: 'ERN', label: <FormattedMessage id="Nakfa" /> },
  { value: 'SZL', label: <FormattedMessage id="Lilangeni" /> },
  { value: 'ETB', label: <FormattedMessage id="Ethiopian Birr" /> },
  { value: 'FKP', label: <FormattedMessage id="Falkland Islands Pound" /> },
  { value: 'FJD', label: <FormattedMessage id="Fiji Dollar" /> },
  { value: 'XPF', label: <FormattedMessage id="CFP Franc" /> },
  { value: 'GMD', label: <FormattedMessage id="Dalasi" /> },
  { value: 'GEL', label: <FormattedMessage id="Lari" /> },
  { value: 'GHS', label: <FormattedMessage id="Ghana Cedi" /> },
  { value: 'GIP', label: <FormattedMessage id="Gibraltar Pound" /> },
  { value: 'GTQ', label: <FormattedMessage id="Quetzal" /> },
  { value: 'GNF', label: <FormattedMessage id="Guinean Franc" /> },
  { value: 'GYD', label: <FormattedMessage id="Guyana Dollar" /> },
  { value: 'HTG', label: <FormattedMessage id="Gourde" /> },
  { value: 'HNL', label: <FormattedMessage id="Lempira" /> },
  { value: 'HKD', label: <FormattedMessage id="Hong Kong Dollar" /> },
  { value: 'HUF', label: <FormattedMessage id="Forint" /> },
  { value: 'ISK', label: <FormattedMessage id="Iceland Krona" /> },
  { value: 'IDR', label: <FormattedMessage id="Rupiah" /> },
  { value: 'IRR', label: <FormattedMessage id="Iranian Rial" /> },
  { value: 'IQD', label: <FormattedMessage id="Iraqi Dinar" /> },
  { value: 'ILS', label: <FormattedMessage id="New Israeli Sheqel" /> },
  { value: 'JMD', label: <FormattedMessage id="Jamaican Dollar" /> },
  { value: 'JOD', label: <FormattedMessage id="Jordanian Dinar" /> },
  { value: 'KZT', label: <FormattedMessage id="Tenge" /> },
  { value: 'KES', label: <FormattedMessage id="Kenyan Shilling" /> },
  { value: 'KPW', label: <FormattedMessage id="North Korean Won" /> },
  { value: 'KRW', label: <FormattedMessage id="Won" /> },
  { value: 'KWD', label: <FormattedMessage id="Kuwaiti Dinar" /> },
  { value: 'KGS', label: <FormattedMessage id="Som" /> },
  { value: 'LAK', label: <FormattedMessage id="Lao Kip" /> },
  { value: 'LBP', label: <FormattedMessage id="Lebanese Pound" /> },
  { value: 'LSL', label: <FormattedMessage id="Loti" /> },
  { value: 'ZAR', label: <FormattedMessage id="Rand" /> },
  { value: 'LRD', label: <FormattedMessage id="Liberian Dollar" /> },
  { value: 'LYD', label: <FormattedMessage id="Libyan Dinar" /> },
  { value: 'CHF', label: <FormattedMessage id="Swiss Franc" /> },
  { value: 'MOP', label: <FormattedMessage id="Pataca" /> },
  { value: 'MKD', label: <FormattedMessage id="Denar" /> },
  { value: 'MGA', label: <FormattedMessage id="Malagasy Ariary" /> },
  { value: 'MWK', label: <FormattedMessage id="Malawi Kwacha" /> },
  { value: 'MYR', label: <FormattedMessage id="Malaysian Ringgit" /> },
  { value: 'MVR', label: <FormattedMessage id="Rufiyaa" /> },
  { value: 'MRU', label: <FormattedMessage id="Ouguiya" /> },
  { value: 'MUR', label: <FormattedMessage id="Mauritius Rupee" /> },
  { value: 'XUA', label: <FormattedMessage id="ADB Unit of Account" /> },
  { value: 'MXN', label: <FormattedMessage id="Mexican Peso" /> },
  {
    value: 'MXV',
    label: <FormattedMessage id="Mexican Unidad de Inversion (UDI)" />,
  },
  { value: 'MDL', label: <FormattedMessage id="Moldovan Leu" /> },
  { value: 'MNT', label: <FormattedMessage id="Tugrik" /> },
  { value: 'MAD', label: <FormattedMessage id="Moroccan Dirham" /> },
  { value: 'MZN', label: <FormattedMessage id="Mozambique Metical" /> },
  { value: 'MMK', label: <FormattedMessage id="Kyat" /> },
  { value: 'NAD', label: <FormattedMessage id="Namibia Dollar" /> },
  { value: 'NPR', label: <FormattedMessage id="Nepalese Rupee" /> },
  { value: 'NIO', label: <FormattedMessage id="Cordoba Oro" /> },
  { value: 'NGN', label: <FormattedMessage id="Naira" /> },
  { value: 'OMR', label: <FormattedMessage id="Rial Omani" /> },
  { value: 'PKR', label: <FormattedMessage id="Pakistan Rupee" /> },
  { value: 'PAB', label: <FormattedMessage id="Balboa" /> },
  { value: 'PGK', label: <FormattedMessage id="Kina" /> },
  { value: 'PEN', label: <FormattedMessage id="Sol" /> },
  { value: 'PHP', label: <FormattedMessage id="Philippine Peso" /> },
  { value: 'PLN', label: <FormattedMessage id="Zloty" /> },
  { value: 'QAR', label: <FormattedMessage id="Qatari Rial" /> },
  { value: 'RON', label: <FormattedMessage id="Romanian Leu" /> },
  { value: 'RWF', label: <FormattedMessage id="Rwanda Franc" /> },
  { value: 'SHP', label: <FormattedMessage id="Saint Helena Pound" /> },
  { value: 'WST', label: <FormattedMessage id="Tala" /> },
  { value: 'STN', label: <FormattedMessage id="Dobra" /> },
  { value: 'SAR', label: <FormattedMessage id="Saudi Riyal" /> },
  { value: 'RSD', label: <FormattedMessage id="Serbian Dinar" /> },
  { value: 'SCR', label: <FormattedMessage id="Seychelles Rupee" /> },
  { value: 'SLE', label: <FormattedMessage id="Leone" /> },
  { value: 'SGD', label: <FormattedMessage id="Singapore Dollar" /> },
  { value: 'XSU', label: <FormattedMessage id="Sucre" /> },
  { value: 'SBD', label: <FormattedMessage id="Solomon Islands Dollar" /> },
  { value: 'SOS', label: <FormattedMessage id="Somali Shilling" /> },
  { value: 'SSP', label: <FormattedMessage id="South Sudanese Pound" /> },
  { value: 'LKR', label: <FormattedMessage id="Sri Lanka Rupee" /> },
  { value: 'SDG', label: <FormattedMessage id="Sudanese Pound" /> },
  { value: 'SRD', label: <FormattedMessage id="Surinam Dollar" /> },
  { value: 'SEK', label: <FormattedMessage id="Surinam Dollar" /> },
  { value: 'CHE', label: <FormattedMessage id="WIR Euro" /> },
  { value: 'CHW', label: <FormattedMessage id="WIR Franc" /> },
  { value: 'SYP', label: <FormattedMessage id="Syrian Pound" /> },
  { value: 'TWD', label: <FormattedMessage id="New Taiwan Dollar" /> },
  { value: 'TJS', label: <FormattedMessage id="Somoni" /> },
  { value: 'TZS', label: <FormattedMessage id="Tanzanian Shilling" /> },
  { value: 'THB', label: <FormattedMessage id="Baht" /> },
  { value: 'TOP', label: <FormattedMessage id="Pa’anga" /> },
  { value: 'TTD', label: <FormattedMessage id="Trinidad and Tobago Dollar" /> },
  { value: 'TND', label: <FormattedMessage id="Tunisian Dinar" /> },
  { value: 'TRY', label: <FormattedMessage id="Turkish Lira" /> },
  { value: 'TMT', label: <FormattedMessage id="Turkmenistan New Manat" /> },
  { value: 'UGX', label: <FormattedMessage id="Uganda Shilling" /> },
  { value: 'UAH', label: <FormattedMessage id="Hryvnia" /> },
  { value: 'AED', label: <FormattedMessage id="UAE Dirham" /> },
  {
    value: 'UYI',
    label: <FormattedMessage id="Uruguay Peso en Unidades Indexadas (UI)" />,
  },
  { value: 'UYW', label: <FormattedMessage id="Unidad Previsional" /> },
  { value: 'UZS', label: <FormattedMessage id="Uzbekistan Sum" /> },
  { value: 'VUV', label: <FormattedMessage id="Vatu" /> },
  { value: 'VES', label: <FormattedMessage id="Bolívar Soberano" /> },
  { value: 'VED', label: <FormattedMessage id="Bolívar Soberano" /> },
  { value: 'VND', label: <FormattedMessage id="Dong" /> },
  { value: 'YER', label: <FormattedMessage id="Yemeni Rial" /> },
  { value: 'ZMW', label: <FormattedMessage id="Zambian Kwacha" /> },
  { value: 'ZWL', label: <FormattedMessage id="Zimbabwe Dollar" /> },
]

const LANGUAGE_CODE_OPTIONS = Object.entries(GMB_LANGUAGE_CODE).map(
  ([languageCode, languageName]) => ({
    value: languageCode,
    label: <FormattedMessage id={languageName} />,
  })
)

const ServiceForm = ({
  formik,
  index,
  service,
  services,
  unusedServices,
  categories,
  createService,
  isCreate = false,
  closeModal,
  opened,
}) => {
  const intl = useIntl()
  const { locationId } = useParams()
  const [serviceOptions, setServiceOptions] = useState([])
  const [categoryOptions, setCategoryOptions] = useState([])
  const [isFreeform, setIsFreeform] = useState(false)
  const [currency, setCurrency] = useState(null)
  const [currencyDisabled, setCurrencyDisabled] = useState(true)
  const [serviceSelect, setServiceSelect] = useState(null)
  const [priceType, setPriceType] = useState(null)
  const [price, setPrice] = useState('')
  const [priceDisabled, setPriceDisabled] = useState(true)
  const [category, setCategory] = useState(null)
  const [language, setLanguage] = useState(null)
  const [description, setDescription] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const [, patchLocationServices] = useAxios(
    {
      url: `/locations/${locationId}/services`,
      method: 'PATCH',
    },
    {
      manual: true,
    }
  )

  function handleOptionCreate(inputValue) {
    setServiceSelect({ label: inputValue, value: inputValue })
    setIsFreeform(true)
  }

  function handleGoogleOption(value) {
    setServiceSelect(value)
    setIsFreeform(false)
  }

  function parseDataToGmbService() {
    const parsedPrice = price?.replace(',', '.')
    const units = price ? String(Math.floor(parsedPrice)) : undefined
    const nanos = units
      ? Number((parsedPrice - +units).toFixed(2)) * ONE_BILLION
      : undefined
    const editedService = {
      ...(priceType?.value !== 'NO_PRICE' && {
        price: {
          currencyCode: currency?.value,
          units,
          nanos,
        },
      }),
    }

    if (
      (priceType.value === 'FREE' && !currency) ||
      (priceType.value === 'FIXED' && !currency)
    ) {
      toast.error(intl.formatMessage({ id: 'Currency is required!' }))
      throw new Error('Currency is required!')
    }

    if (priceType.value === 'FIXED' && !price) {
      toast.error(intl.formatMessage({ id: 'Price is required!' }))
      throw new Error('Price is required!')
    }

    if (!serviceSelect) {
      toast.error(intl.formatMessage({ id: 'Service is required!' }))
      throw new Error('Service is required!')
    }

    if (isFreeform) {
      if (!category) {
        toast.error(intl.formatMessage({ id: 'Category is required!' }))
        throw new Error('Category is required!')
      }
      editedService.freeFormServiceItem = {
        label: {
          displayName: serviceSelect?.value,
          description: description || undefined,
          languageCode: language?.value,
        },
        category: category?.value,
      }
    } else {
      editedService.structuredServiceItem = {
        serviceTypeId: serviceSelect?.value,
        description: description || undefined,
      }
    }

    return editedService
  }

  async function handleSaveService() {
    try {
      const serviceItems = _.cloneDeep(formik.values.serviceItems || [])
      const editedService = parseDataToGmbService()

      serviceItems[index] = editedService

      setIsLoading(true)
      await patchLocationServices({
        data: {
          services: serviceItems,
        },
      })
        .then(() => {
          setIsLoading(false)
          formik.setFieldValue('serviceItems', serviceItems)
          toast.success(
            intl.formatMessage({ id: 'Service saved successfully!' })
          )
          closeModal()
        })
        .catch(error => {
          setIsLoading(false)
          console.error(error.response.data)
          toast.error(
            intl.formatMessage({
              id:
                'An error occurred while trying to save the service. Please try again.',
            })
          )
        })
    } catch (error) {
      console.error(error)
    }
  }

  async function handleDeleteService() {
    try {
      const serviceItems = _.cloneDeep(formik.values.serviceItems || [])
      serviceItems.splice(index, 1)

      setIsLoading(true)
      await patchLocationServices({
        data: {
          services: serviceItems,
        },
      })
        .then(() => {
          setIsLoading(false)
          formik.setFieldValue('serviceItems', serviceItems)
          toast.success(
            intl.formatMessage({ id: 'Service deleted successfully!' })
          )
        })
        .catch(error => {
          setIsLoading(false)
          console.error(error.response.data)
          toast.error(
            intl.formatMessage({
              id:
                'An error occurred while trying to delete the service. Please try again.',
            })
          )
        })
    } catch (error) {
      console.error(error)
    }
  }

  async function handleAddService() {
    try {
      const serviceItems = _.cloneDeep(formik.values.serviceItems || [])
      const addedService = parseDataToGmbService()
      serviceItems.push(addedService)

      setIsLoading(true)
      await patchLocationServices({
        data: {
          services: serviceItems,
        },
      })
        .then(() => {
          setIsLoading(false)
          formik.setFieldValue('serviceItems', serviceItems)
          toast.success(
            intl.formatMessage({ id: 'Service added successfully!' })
          )
          closeModal()
        })
        .catch(error => {
          setIsLoading(false)
          console.error(error.response.data)
          toast.error(
            intl.formatMessage({
              id:
                'An error occurred while trying to add the service. Please try again.',
            })
          )
        })
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    const hasPrice = service?.price?.units
    const hasCurrency = service?.price?.currencyCode
    const isFree = !hasPrice && hasCurrency
    const isNoPrice = !hasPrice && !hasCurrency

    setIsFreeform(!!service?.freeFormServiceItem)
    setPriceType(
      isFree
        ? PRICE_OPTIONS[1]
        : isNoPrice
        ? PRICE_OPTIONS[0]
        : PRICE_OPTIONS[2]
    )

    if (!service && !createService) return
    if (!isCreate) {
      const currency = service?.price?.currencyCode
      const category = service?.freeFormServiceItem?.category
      const language = service?.freeFormServiceItem?.label?.languageCode
      const description =
        service?.freeFormServiceItem?.label?.description ||
        service?.structuredServiceItem?.description

      setCurrency(
        currency
          ? {
              value: currency,
              label: CURRENCY_CODE_OPTIONS.find(({ value }) => {
                return value === currency
              })?.label,
            }
          : null
      )
      setCategory(
        category
          ? {
              value: category,
              label: categories.find(({ name }) => name === category)
                ?.displayName,
            }
          : null
      )
      setLanguage(
        language
          ? {
              value: language,
              label: LANGUAGE_CODE_OPTIONS.find(({ value }) => {
                return value === language
              })?.label,
            }
          : null
      )
      setServiceSelect({
        value:
          service.structuredServiceItem?.serviceTypeId ||
          service.freeFormServiceItem?.label?.displayName,
        label: service.structuredServiceItem?.serviceTypeId
          ? services.find(
              ({ serviceTypeId }) =>
                serviceTypeId ===
                  service.structuredServiceItem?.serviceTypeId ||
                serviceTypeId ===
                  service.freeFormServiceItem?.label?.displayName
            )?.displayName
          : service.freeFormServiceItem?.label?.displayName,
      })
      setPrice(
        service?.price?.units
          ? +service.price?.units + service.price?.nanos / ONE_BILLION
          : null
      )
      setDescription(description)
    } else {
      setServiceSelect({
        value: createService.serviceTypeId,
        label: createService.displayName,
      })
    }
  }, [service, opened])

  useEffect(() => {
    if (!unusedServices?.length) return

    const options = unusedServices.map(service => ({
      value: service.serviceTypeId,
      label: service.displayName,
    }))
    setServiceOptions(options)
  }, [unusedServices])

  useEffect(() => {
    if (!categories?.length) return

    const options = categories.map(category => ({
      value: category.name,
      label: category.displayName,
    }))
    setCategoryOptions(options)
  }, [categories])

  useEffect(() => {
    if (!priceType) return

    const { priceDisabled, currencyDisabled } = PRICE_STATES[priceType?.value]
    setPriceDisabled(priceDisabled)
    if (priceDisabled) setPrice('')
    setCurrencyDisabled(currencyDisabled)
    if (currencyDisabled) setCurrency('')
  }, [priceType])

  return (
    <div className="edit-service">
      {isFreeform ? (
        <>
          <ServiceFormDiv>
            <div className="free first-row">
              <FormGroup>
                <label
                  htmlFor={`serviceItems.${index}.freeFormServiceItem.label.languageCode`}
                  className="d-flex justify-content-between"
                >
                  <FormattedMessage id="Language" />
                </label>
                <Select
                  name={`serviceItems.${index}.freeFormServiceItem.label.languageCode`}
                  placeholder={<FormattedMessage id="Select the language" />}
                  value={language}
                  onChange={value => setLanguage(value)}
                  defaultValue={{
                    value: 'BRL',
                    label: <FormattedMessage id="Brazilian Real" />,
                  }}
                  options={LANGUAGE_CODE_OPTIONS}
                  isDisabled={isLoading}
                  isClearable
                />
              </FormGroup>
              <FormGroup className="d-flex flex-column">
                <label
                  htmlFor={`serviceItems.${index}.price.currencyCode`}
                  className="d-flex justify-content-between"
                >
                  <FormattedMessage id="Currency Code" />
                  {!currencyDisabled && '*'}
                </label>
                <Select
                  name={`serviceItems.${index}.price.currencyCode`}
                  placeholder={<FormattedMessage id="Select currency" />}
                  value={currency}
                  onChange={value => setCurrency(value)}
                  options={CURRENCY_CODE_OPTIONS}
                  defaultValue={{ value: 'NO_PRICE', label: '' }}
                  isDisabled={currencyDisabled || isLoading}
                  isClearable
                />
              </FormGroup>
            </div>
            <div className="structured second-row">
              <FormGroup>
                <label
                  htmlFor={`serviceItems.${index}.freeFormServiceItem.serviceTypeId`}
                  className="d-flex justify-content-between"
                >
                  <FormattedMessage id="Enter the Service" />*
                  {isFreeform && (
                    <CustomTag>
                      <FormattedMessage id="Custom" />
                    </CustomTag>
                  )}
                </label>
                <CreatableSelect
                  name={`serviceItems.${index}.freeFormServiceItem.serviceTypeId`}
                  onCreateOption={handleOptionCreate}
                  onChange={handleGoogleOption}
                  options={serviceOptions}
                  defaultValue={{
                    value:
                      formik.values.serviceItems[index]?.structuredServiceItem
                        ?.serviceTypeId,
                    label: services.find(
                      ({ serviceTypeId }) =>
                        serviceTypeId ===
                        service?.structuredServiceItem?.serviceTypeId
                    )?.displayName,
                  }}
                  formatCreateLabel={inputValue => (
                    <NewServiceOption
                      onClick={() =>
                        setServiceSelect({
                          value: inputValue,
                          label: inputValue,
                        })
                      }
                    >
                      <Plus size={12} stroke-width="3" color="#6236ff" />
                      <FormattedMessage id="Add custom service" />
                    </NewServiceOption>
                  )}
                  noOptionsMessage={() =>
                    intl.formatMessage({ id: 'Service already selected' })
                  }
                  isDisabled={isLoading}
                  value={serviceSelect}
                />
              </FormGroup>
              <FormGroup>
                <label
                  htmlFor={`serviceItems.${index}.price`}
                  className="d-flex justify-content-between"
                >
                  <FormattedMessage id="Price" />*
                </label>
                <InputGroup className="price-grouping">
                  <Select
                    styles={{
                      container: baseStyles => ({
                        ...baseStyles,
                        minWidth: '50%',
                      }),
                      control: baseStyles => ({
                        ...baseStyles,
                        borderRadius: '4px 0 0 4px',
                        backgroundColor: '#FAFAFA',
                      }),
                      singleValue: baseStyles => ({
                        ...baseStyles,
                        color: '#6D7278',
                      }),
                    }}
                    name={`serviceItems.${index}.price`}
                    options={PRICE_OPTIONS}
                    defaultValue={{
                      value: 'NO_PRICE',
                      label: <FormattedMessage id="No price" />,
                    }}
                    value={priceType}
                    onChange={value => setPriceType(value)}
                    isDisabled={isLoading}
                  />
                  <Input
                    placeholder="$100,00"
                    onChange={event => {
                      const value = event.target.value
                      const regex = /([0-9]*[.,]{0,1}[0-9]{0,2})/

                      setPrice(value.match(regex)[0])
                    }}
                    disabled={priceDisabled || isLoading}
                    value={price}
                  />
                </InputGroup>
              </FormGroup>
            </div>
            <div className="structured third-row">
              <FormGroup>
                <label
                  htmlFor={`serviceItems.${index}.freeFormServiceItem.category`}
                  className="d-flex justify-content-between"
                >
                  <FormattedMessage id="Select the category for the custom service" />
                  *
                </label>
                <Select
                  name={`serviceItems.${index}.freeFormServiceItem.category`}
                  options={categoryOptions}
                  value={category}
                  onChange={value => setCategory(value)}
                  isDisabled={isLoading}
                />
              </FormGroup>
            </div>
            <div className="structured fourth-row">
              <FormGroup>
                <label
                  htmlFor={`serviceItems.${index}.freeFormServiceItem.description`}
                  className="d-flex justify-content-between"
                >
                  <FormattedMessage id="Service Description" />
                </label>
                <Textarea
                  maxLength={300}
                  onChange={event => {
                    const value = event.target.value
                    setDescription(value)
                  }}
                  placeholder={intl.formatMessage({
                    id: 'Describe your service here...',
                  })}
                  value={description}
                  disabled={isLoading}
                />
              </FormGroup>
            </div>
          </ServiceFormDiv>
        </>
      ) : (
        <ServiceFormDiv>
          <div className="structured first-row">
            <FormGroup>
              <label
                htmlFor={`serviceItems.${index}.price.currencyCode`}
                className="d-flex justify-content-between"
              >
                <FormattedMessage id="Currency Code" />
                {!currencyDisabled && '*'}
              </label>
              <Select
                name={`serviceItems.${index}.price.currencyCode`}
                placeholder={<FormattedMessage id="Select currency" />}
                value={currency}
                onChange={value => setCurrency(value)}
                options={CURRENCY_CODE_OPTIONS}
                isDisabled={currencyDisabled || isLoading}
                isClearable
              />
            </FormGroup>
          </div>
          <div className="structured second-row">
            <FormGroup>
              <label
                htmlFor={`serviceItems.${index}.structuredServiceItem.serviceTypeId`}
                className="d-flex justify-content-between"
              >
                <FormattedMessage id="Enter the Service" />*
              </label>
              <CreatableSelect
                name={`serviceItems.${index}.structuredServiceItem.serviceTypeId`}
                onCreateOption={handleOptionCreate}
                onChange={handleGoogleOption}
                options={serviceOptions}
                defaultValue={{
                  value:
                    formik.values.serviceItems[index]?.structuredServiceItem
                      ?.serviceTypeId,
                  label: services.find(
                    ({ serviceTypeId }) =>
                      serviceTypeId ===
                      service?.structuredServiceItem?.serviceTypeId
                  )?.displayName,
                }}
                formatCreateLabel={inputValue => (
                  <NewServiceOption
                    onClick={() =>
                      setServiceSelect({
                        value: inputValue,
                        label: inputValue,
                      })
                    }
                  >
                    <Plus size={12} stroke-width="3" color="#6236ff" />
                    <FormattedMessage id="Add custom service" />
                  </NewServiceOption>
                )}
                noOptionsMessage={() =>
                  intl.formatMessage({ id: 'Service already selected' })
                }
                value={serviceSelect}
                isDisabled={isLoading}
              />
            </FormGroup>
            <FormGroup>
              <label
                htmlFor={`serviceItems.${index}.price`}
                className="d-flex justify-content-between"
              >
                <FormattedMessage id="Price" />*
              </label>
              <InputGroup className="price-grouping">
                <Select
                  styles={{
                    container: baseStyles => ({
                      ...baseStyles,
                      minWidth: '50%',
                    }),
                    control: baseStyles => ({
                      ...baseStyles,
                      borderRadius: '4px 0 0 4px',
                      backgroundColor: '#FAFAFA',
                    }),
                    singleValue: baseStyles => ({
                      ...baseStyles,
                      color: '#6D7278',
                    }),
                  }}
                  name={`serviceItems.${index}.price`}
                  options={PRICE_OPTIONS}
                  defaultValue={{
                    value: 'NO_PRICE',
                    label: <FormattedMessage id="No price" />,
                  }}
                  value={priceType}
                  onChange={value => setPriceType(value)}
                  isDisabled={isLoading}
                />
                <Input
                  placeholder="$100,00"
                  onChange={event => {
                    const value = event.target.value
                    const regex = /([0-9]*[.,]{0,1}[0-9]{0,2})/

                    setPrice(value.match(regex)[0])
                  }}
                  disabled={priceDisabled || isLoading}
                  value={price}
                />
              </InputGroup>
            </FormGroup>
          </div>
          <div className="structured fourth-row">
            <FormGroup>
              <label
                htmlFor={`serviceItems.${index}.structuredServiceItem.description`}
                className="d-flex justify-content-between"
              >
                <FormattedMessage id="Service Description" />
              </label>
              <Textarea
                maxLength={300}
                onChange={event => {
                  const value = event.target.value
                  setDescription(value)
                }}
                placeholder={intl.formatMessage({
                  id: 'Describe your service here...',
                })}
                disabled={isLoading}
                value={description}
              />
            </FormGroup>
          </div>
        </ServiceFormDiv>
      )}
      {!isCreate && (
        <ServiceButtonsDiv>
          <button
            className="delete"
            onClick={handleDeleteService}
            disabled={isLoading}
          >
            <FormattedMessage id="Delete service" />
          </button>
          <button
            className="save"
            onClick={handleSaveService}
            disabled={isLoading}
          >
            <FormattedMessage id="Save" />
          </button>
        </ServiceButtonsDiv>
      )}
      {isCreate && (
        <>
          <hr />
          <ServiceButtonsDiv>
            <button className="cancel" onClick={() => closeModal()}>
              <FormattedMessage id="Cancel" />
            </button>
            <button
              className="save"
              onClick={handleAddService}
              disabled={isLoading}
            >
              <FormattedMessage id="Add Service" />
            </button>
          </ServiceButtonsDiv>
        </>
      )}
    </div>
  )
}

const ServiceCard = ({
  service,
  services,
  index,
  formik,
  unusedServices,
  categories,
}) => {
  const [open, setOpen] = useState(false)

  const id =
    service?.structuredServiceItem?.serviceTypeId ||
    kebabCase(service?.freeFormServiceItem?.label?.displayName)
  const displayName =
    service?.freeFormServiceItem?.label?.displayName ||
    services.find(
      ({ serviceTypeId }) =>
        serviceTypeId === service?.structuredServiceItem?.serviceTypeId
    )?.displayName
  const price = service?.price?.units
  const nanos = service?.price?.nanos
  const currency = service?.price?.currencyCode
  const finalPrice = +price + nanos / ONE_BILLION
  const isNoPrice = !service?.price?.currencyCode && !service?.price?.units
  const isFree = service?.price?.currencyCode && !service?.price?.units
  const description =
    service?.freeFormServiceItem?.label?.description ||
    service?.structuredServiceItem?.description

  return (
    <details key={id} className="d-flex flex-column">
      <summary onClick={() => setOpen(prevState => !prevState)}>
        <div>
          <div className="service-name">{displayName}</div>
          {description && <div>{description}</div>}
        </div>
        <div className="service-info">
          <div className="price">
            {isNoPrice && <FormattedMessage id="No price" />}
            {isFree && <FormattedMessage id="Free" />}
            {!isNoPrice && !isFree && (
              <>
                {GMB_CURRENCY_CODE[currency]} {finalPrice}
              </>
            )}
          </div>
          <div>
            {open ? (
              <ChevronUp size={20} color="#606060" />
            ) : (
              <ChevronDown size={20} color="#606060" />
            )}
          </div>
        </div>
      </summary>
      <div className="service-edit">
        <ServiceForm
          service={service}
          services={services}
          index={index}
          formik={formik}
          unusedServices={unusedServices}
          categories={categories}
          opened={open}
        />
      </div>
    </details>
  )
}

const EditServicesTab = ({ formik }) => {
  const [services, setServices] = useState([])
  const [registeredServices, setRegisteredServices] = useState([])
  const [unusedServices, setUnusedServices] = useState([])
  const [categories, setCategories] = useState([])
  const [modal, setModal] = useState(false)
  const [modalService, setModalService] = useState(null)

  function filterByRegisteredServices(service) {
    return !registeredServices.find(
      registeredService =>
        registeredService?.structuredServiceItem?.serviceTypeId ===
        service.serviceTypeId
    )
  }

  function openModal() {
    setModal(true)
  }

  useEffect(() => {
    if (!formik.values) return
    const primaryServices =
      formik.values.categories.primaryCategory.serviceTypes || []
    const secondaryServices = (
      formik.values.categories?.secondaryCategory || []
    )
      .map(category => category.serviceTypes)
      .flat()

    const primaryCategory = formik.values?.categories?.primaryCategory
    const secondaryCategory =
      formik.values?.categories?.additionalCategories || []

    setRegisteredServices(formik.values.serviceItems || [])
    setServices([...primaryServices, ...secondaryServices])
    setUnusedServices(services.filter(filterByRegisteredServices))
    setCategories([primaryCategory, ...secondaryCategory])
  }, [formik.values])

  useEffect(() => {
    if (!modal) setModalService(null)
  }, [modal])

  return (
    <ServiceDiv>
      <StyledModal size="lg" centered={true} backdrop={true} isOpen={modal}>
        <div className="service-modal-header">
          <div className="header-info">
            <button onClick={() => setModal(false)}>
              <ArrowLeft size={20} color="#718096" />
            </button>
            <FormattedMessage id="Add new service" />
          </div>
          <div className="header-close">
            <button onClick={() => setModal(false)}>
              <X size={20} color="#000" />
            </button>
          </div>
        </div>
        <hr />
        <ServiceForm
          services={services}
          formik={formik}
          unusedServices={unusedServices}
          categories={categories}
          createService={modalService}
          closeModal={() => setModal(false)}
          isCreate
        />
      </StyledModal>

      <div className="d-flex flex-row justify-content-between">
        <h4>
          <FormattedMessage id="Registered Services:" />
        </h4>
        <button className="add-service" onClick={openModal}>
          <div>+</div>
          <FormattedMessage id="Add new service" />
        </button>
      </div>

      <div className="service-list">
        {registeredServices.map((service, index) => (
          <ServiceCard
            key={index}
            index={index}
            formik={formik}
            service={service}
            services={services}
            unusedServices={unusedServices}
            categories={categories}
          />
        ))}
      </div>

      <div className="d-flex flex-column justify-content-between suggested-services">
        <h4>
          <FormattedMessage id="Suggested Services:" />
        </h4>
        <div className="service-list">
          {unusedServices.map((service, index) => (
            <button
              key={index}
              onClick={() => {
                setModalService(service)
                openModal(service)
              }}
            >
              <div>+</div>
              <div>{service.displayName}</div>
            </button>
          ))}
        </div>
      </div>
    </ServiceDiv>
  )
}

const ServiceDiv = styled.div`
  h4 {
    color: #2c2c2c;
    font-size: 1.5rem;
    font-weight: 400;
  }

  .add-service {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 14px;
    height: 40px;
    color: #6236ff;
    gap: 8px;
    border-radius: 4px;
    border: 1px solid #6236ff;
    background-color: transparent;
  }

  .service-list {
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    gap: 8px;

    details {
      display: flex;
      justify-content: space-between;

      border-radius: 8px;
      border: 1px solid #cbd5e0;
    }

    summary {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 32px;
      list-style: none;

      .service-name {
        font-size: 1.2rem;
        font-family: Montserrat;
        font-weight: 500;
        color: #000;
      }

      .service-info {
        display: flex;
        justify-content: space-around;
        align-items: center;
        gap: 8px;
        min-width: 20%;

        .price {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 4px 12px;
          border-radius: 6px;
          border: 1px solid #80839029;
          background-color: #80839014;
          font-size: 12px;
          color: #484848;
        }
      }
    }
  }

  .suggested-services {
    margin-top: 20px;

    .service-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 8px;

      button {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 12px;
        gap: 8px;
        color: #2c2c2c;
        border-radius: 4px;
        border: 1px solid #a8a8a8;
        background-color: transparent;
        font-weight: 500;
      }
    }
  }

  .edit-service {
    display: flex;
    flex-direction: column;
    padding: 16px;
  }
`

const ServiceFormDiv = styled.div`
  label {
    color: #000;
    font-weight: 500;
    margin-bottom: 8px;
  }

  .structured.second-row {
    display: flex;
    flex-direction: row;
    gap: 16px;

    .form-group:nth-child(1) {
      width: 60%;
    }

    .form-group:nth-child(2) {
      width: 40%;
    }
  }

  .free.first-row {
    display: flex;
    flex-direction: row;
    gap: 16px;

    .form-group:nth-child(1) {
      width: 50%;
    }

    .form-group:nth-child(2) {
      width: 50%;
    }
  }

  .price-grouping:focus-within {
    > div {
      border-color: #2684ff;
    }

    > input {
      box-shadow: 0 0 0 1px #2684ff;
      border-color: #2684ff;
    }
  }

  .price-grouping {
    > div {
      height: 38px;
    }

    > input {
      height: 38px;
    }
  }
`

const ServiceButtonsDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 16px;

  button.delete {
    padding: 8px 16px;
    border: none;
    background-color: transparent;
    color: #ed5f5f;
    font-weight: 600;

    &:disabled {
      cursor: progress;
      color: #6b7280;
    }
  }

  button.save {
    padding: 8px 16px;
    border: none;
    border-radius: 6px;
    background-color: #6bb156;
    color: #fff;
    font-weight: 600;

    &:disabled {
      cursor: progress;
      background-color: #d1d5db;
      color: #6b7280;
    }
  }

  button.cancel {
    padding: 8px 16px;
    border: 1px solid #979797;
    border-radius: 6px;
    background-color: transparent;
    color: #979797;
    font-weight: 600;

    &:disabled {
      cursor: progress;
      color: #6b7280;
    }
  }
`

const StyledModal = styled(Modal)`
  .modal-content {
    padding: 20px;
  }

  hr {
    width: 100%;
  }

  .service-modal-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    .header-info {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 16px;
      color: #000;
      font-weight: 700;

      button {
        border-radius: 99999px;
        aspect-ratio: 1/1;
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #f7f7f7;
        border: none;
      }
    }

    .header-close {
      button {
        border: none;
        padding: 8px;
        margin: none;
        background-color: transparent;
        color: #000;
      }
    }
  }
`

const CustomTag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1px 12px;
  border-radius: 99px;
  background-color: #f1f0fd;
  color: #7367f0;
`

const NewServiceOption = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #6236ff;
  background-color: transparent;
  color: #6236ff;
  font-weight: 500;
`

export default EditServicesTab
